import { Component } from 'react'

import { decodeQueryString, encodeQueryString } from '../queryString'
import { TimeFrames } from './types'

interface MenuProps<Key> {
  isDetailOpen?: boolean
  activePage: string
  currencies?: {
    currencies: string[]
    active: string
    link: (currency: string) => string
  }
  timeframes: TimeFrames<Key>
  company?: string
}

class Menu<Key extends string> extends Component<MenuProps<Key>> {
  render() {
    var { activePage, currencies } = this.props
    var timeframesMenu = this.props.timeframes
    var params = decodeQueryString()
    var queryParams = (Object.keys(params).length > 0 ? '?' : '') + encodeQueryString({ ...params })
    return (
      <div className="menu flex justify-center">
        <ul className="menu-pages">
          <li className={activePage === 'quotes' ? 'is-active' : ''}>
            <a href={`/crypto.ashx${queryParams}`}>Quotes</a>
          </li>
          <li className={activePage === 'performance' ? 'is-active' : ''}>
            <a href={`/crypto_performance.ashx${queryParams}`}>Performance</a>
          </li>
          <li className={activePage === 'charts' ? 'is-active' : ''}>
            <a href={`/crypto_charts.ashx${queryParams}`}>Charts</a>
          </li>
        </ul>
        {currencies && (
          <ul className="menu-timeframes menu-currencies">
            {currencies.currencies.map((currency) => (
              <li className={currencies?.active === currency ? 'is-active' : ''} key={currency}>
                <a href={currencies?.link(currency)} title={currency}>
                  {currency}
                </a>
              </li>
            ))}
          </ul>
        )}
        <ul className="menu-timeframes">
          {timeframesMenu.timeframes.map((timeframe) => (
            <li className={timeframesMenu.active === timeframe.key ? 'is-active' : ''} key={timeframe.key}>
              <a
                href={timeframesMenu.link(timeframe.key as Key)}
                onClick={timeframesMenu.onClick.bind(this, timeframe.key as Key)}
                title={timeframe.title}
              >
                {timeframe.value}
              </a>
            </li>
          ))}
        </ul>
      </div>
    )
  }
}

export default Menu
